
    // this file was auto generated by python script
    import Tag from './Tag';
    export default Tag;
    